import { render, staticRenderFns } from "./ProductCharacteristics.vue?vue&type=template&id=786789e8&"
import script from "./ProductCharacteristics.vue?vue&type=script&lang=js&"
export * from "./ProductCharacteristics.vue?vue&type=script&lang=js&"
import style0 from "./ProductCharacteristics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports